import { render, staticRenderFns } from "./contractTable.vue?vue&type=template&id=5c0b2073&scoped=true&"
import script from "./contractTable.vue?vue&type=script&lang=js&"
export * from "./contractTable.vue?vue&type=script&lang=js&"
import style0 from "./contractTable.vue?vue&type=style&index=0&id=5c0b2073&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0b2073",
  null
  
)

export default component.exports